//dev environment
//export const host = "https://dev-laminat.bitloft.de";

//production environment
export const host = process.env.REACT_APP_HOST;
//export const host = "https://dev-laminat.bitloft.de";
//export const host = "http://localhost:8300";
